module.exports = __webpack_public_path__ + "media/images/career_camp/2022/home_ruins_1-d7d21942045f3bdd8414c97b3c9b8f82.svg";